export function getHandledError () {
  const error = new Error()
  error.name = 'HandledError'
  return error
}

export function getOperationError () {
  const error = new Error()
  error.name = 'OperationError'
  return error
}

export function getAbnormalError () {
  const error = new Error()
  error.name = 'AbnormalError'
  return error
}

export function isHandledError (err) {
  return err.name === 'HandledError'
}

export function isValidationError (err) {
  return err.name === 'ValidationError'
}



// WEBPACK FOOTER //
// ./src/lib/error-utils.js